export default class Logs {

	constructor(name) {

		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			query: '',
			groupId: null,

			Data: [],
			Terms: {},
			Items: {},

			menu: {
				taxonomy: {}
			},

			init(ItemId,groupId) {
				var vm = this
				var xhttp = new XMLHttpRequest();
				vm.Data = []
				vm.loading = true
				xhttp.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						vm.Data = JSON.parse(this.responseText);
					}

					if( vm.Data == undefined){
						vm.Data = [];
					}
				}

				xhttp.open('get', '/api/reporting-menu', true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				// setTimeout(function() {
					xhttp.send();
				// }, 500)
			},

			selectedTaxonomy(Taxomony){
				this.Terms = Object.values(Taxomony.terms)
			},
			
			selectedTerm(Term){
				console.log( Term.items );
				this.Items = Object.values(Term.items)
			},
			
			selectedItem(Item){
				window.location.href = '/employee/item/' + Item.id
			}
			
		}

	}

}